import {Component, OnInit, Inject} from 'ng-metadata/core';
import {LoginIframeService} from '../loginIframe.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {UserSessionManagerService} from '../../security/userSessionManager.service';
import {PersonalizeResultsButtonService} from "../../search/personalization/personalizationButton/personalizeResultsButton.service";
import {SilentLoginService} from "./silentLogin.service";

@Component({
    selector: 'prm-silent-login',
    templateUrl: 'components/primoExplore/silentLogin/silent-login.html',
})

export class PrmSilentLogin implements OnInit{


    constructor( @Inject('$rootScope') private $rootScope: ng.IRootScopeService ,
                 private loginIframeService:LoginIframeService ,
                 private jwtUtilService: JwtUtilService,
                 private userSessionManagerService : UserSessionManagerService,
                 private personalizeResultsButtonService : PersonalizeResultsButtonService,
                 @Inject('SessionTimeoutService') private sessionTimeoutService,
                 private silentLoginService: SilentLoginService,
                 @Inject('$state') private $state: ng.ui.IStateService) {
        this.addEventListenerForJwt();
    }

    ngOnInit() {
    }

    private addEventListenerForJwt(){
        // the code of throwing the event comes from the server as a response to the iframe
        // the code is
        // "<script type='text/javascript'>window.parent.postMessage({event_id: 'jwt_in_iframe',jwt:'"+jwt+"'},'*')</script>";
        // located in com.exlibris.primo.servlets.authentication.PrimoPostLoginServlet
        // in the method postPrimoExploreLoginRedirect(HttpServletRequest, HttpServletResponse, Map<String, String>, String)
        window.addEventListener("message", (event)=>{this.receiveJwtFromIframe(event)}, false);
    }

    public receiveJwtFromIframe(event){
        if(event.data.event_id !=='jwt_in_iframe'){
            console.log('got the wrong message,  event.data.event_id= '+event.data.event_id);
            return;
        }
        if (event.data.jwt) {
            this.userSessionManagerService.login(event.data.jwt);
            this.$state.reload();
        }

        if (this.jwtUtilService.isGuest()) {
            let hasNext = this.loginIframeService.advanceToNextUrl();
            this.jwtUtilService.backFromLoginIframe = !hasNext;
        } else {
            this.jwtUtilService.backFromLoginIframe = true;
            this.postLoginAction();
        }
        if (this.jwtUtilService.backFromLoginIframe && this.silentLoginService.silentLoginInprogressPromise){  //silent login has ended either successful or failed
            this.silentLoginService.silentLoginEnd(); //signal that silent login has ended
        }
        this.$rootScope.$apply();
    }

    private postLoginAction(){
        this.sessionTimeoutService.startSession(false);
        this.silentLoginService.silentLoginAppDelayTimer.then(()=>{
            this.silentLoginService.showSilentLoginToast();
        }, (error) => {
            // nothing to do but need to handle error, so we don't get unhandled rejection error in console
        });
        this.userSessionManagerService.signInObservable.next(); //fire observable so observers can respond to silent login event
        this.$rootScope.$emit('silentLogin');
        this.personalizeResultsButtonService.updatePersonalization(this.jwtUtilService.getDecodedToken().viewId);
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/silentLogin/silentLogin.directive.ts